import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import type {
  IApiRequestDownloadLiveStreamResponseBody,
  IApiRequestDownloadLiveStreamsRequestParams,
} from '../LiveStreamsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseRefreshLiveStreamMutationValues = {
  appId: string;
  liveStreamId: string;
  params: IApiRequestDownloadLiveStreamsRequestParams;
};

export const useRequestDownloadLiveStreamsMutation = (): UseMutationResult<
  IApiRequestDownloadLiveStreamResponseBody,
  unknown,
  IUseRefreshLiveStreamMutationValues
> => {
  const api = useApi();

  return useMutation({
    mutationFn: (values) =>
      api.liveStreams.requestDownload(
        values.appId,
        values.liveStreamId,
        values.params,
      ),
  });
};
